export const Home = () => {
  return <>HOME</>;
};
